// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__ehO4f","spinner1":"Spinner_spinner1__zLQQK","slow":"Spinner_slow__9-zkM","linear":"Spinner_linear__pDkk3"};